<template>
  <InfuseSlideInLayout
    :title="t('e_connector.messages.messageId', { id: message?.id })"
    :parent-to="{ name: 'messages' }"
  >
    <template #header>
      <div class="mb-1">
        <h1 class="text-xl font-bold text-neutral-700">
          <span>{{ t('e_connector.messages.messageId', { id: message?.id }) }}</span>

          <InfuseTag v-if="message?.messageVersion" :inline="true" class="ml-4 font-medium" variant="neutral">
            <font-awesome-icon :icon="['fal', 'signal-stream']" class="mr-2" />
            OCPP-{{ message?.messageVersion }}
          </InfuseTag>

          <InfuseTag v-if="message?.messageAction" :inline="true" class="ml-4 font-medium" variant="neutral">
            <font-awesome-icon :icon="['fal', 'envelope']" class="mr-2" />
            {{ message?.messageAction }}
          </InfuseTag>
        </h1>

        <div class="text-xs font-extralight text-neutral-500">
          <span>{{ formatDate(message?.date) }}</span>
        </div>
      </div>
    </template>

    <InfuseRouterTabLayout v-if="message" :model="message" @reload-model="refresh" />
    <InfuseSpinner v-else class="flex items-center justify-center p-16" size="medium" />
  </InfuseSlideInLayout>
</template>

<script setup lang="ts">
import { InfuseRouterTabLayout, InfuseSlideInLayout } from '@infuse/ui/layouts';
import { formatDate } from '@infuse/ui/utils';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { InfuseSpinner, InfuseTag } from '@infuse/ui/components';
import { useRedirectOnNotFound } from '@infuse/e-connector/shared/composables';
import { useMessage } from '@infuse/e-connector/message/queries';

const { t } = useI18n();

const route = useRoute();
const id = computed(() => route.params.id?.toString());

const { message, fetchMessageId, isError, error } = useMessage();
useRedirectOnNotFound(isError, error);

watch(id, () => (fetchMessageId.value = id.value), { immediate: true });

async function refresh() {
  fetchMessageId.value = id.value;
}
</script>
